export const FILTER_KEY_PREFIX = 'filter_'
export const prefixFilterKey = (filterName: string) =>
  `${FILTER_KEY_PREFIX}${filterName}`

export const stripPrefixFromFilterKey = (filterName: string) =>
  filterName.replace(FILTER_KEY_PREFIX, '')
